import reduce from "./reduce.js";
import go1Sync from "../_internal/go1Sync.js";
export default function go() {
  for (var _len = arguments.length, _ = new Array(_len), _key = 0; _key < _len; _key++) {
    _[_key] = arguments[_key];
  }

  return reduce(go1Sync, _);
}